const getFormattedPrice = priceNumber => {
    if (priceNumber === undefined || priceNumber === "" || priceNumber === null) {
        return "";
    }

    if (Number.isInteger(priceNumber)) {
        const formattedPrice = Number(priceNumber).toLocaleString("nl-NL", {
            maximumFractionDigits: 0
        });
        return `${formattedPrice},-`;
    }

    return Number(priceNumber).toLocaleString("nl-NL", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

export {getFormattedPrice}
